import {Component} from 'react';
import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import {connect} from 'react-redux';
import InlineCKEditor from '../common/editor/inline-editor'
import {loadPageContent} from '../../actions/content';
import bluHeaderImage from '../../assets/img/blu_banner_1409.jpg';

import './blu.css'

class BluPage extends Component {

  constructor(props) {
    super(props);
    this.pageSlug = props.pageSlug;
  }

  componentDidMount() {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    const {contents, attributes, pageSlug} = this.props;
    const title = attributes ? attributes.name : '';
    return (
      <Grid bsClass="container" fluid className="blu">
        <Row>
          <Col lg={12} className="bluHeader">
            <img src={bluHeaderImage}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="bluTitle">
            <h1>{title}</h1>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="bluContent">
            <InlineCKEditor
              identifier={`${pageSlug}_blu_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={contents[`${pageSlug}_blu_content_text`]}/>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contents: state.content.list,
    attributes: state.content.page.attributes
  };
};

export default connect(mapStateToProps)(BluPage);



// WEBPACK FOOTER //
// ./src/components/blu/blu-page.jsx